import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { AnimatePresence, motion } from 'framer-motion';
import './HomeProjects.css';
import img1 from '../../assets/Home/Project/Img1.webp';
import img2 from '../../assets/Home/Project/Img2.webp';
import img3 from '../../assets/Home/Project/Img3.webp';


const projects = [
  {
    id: "01",
    tag: "UTILITY-SCALE SOLAR",
    title: "1.14 GWp Solar Park Development",
    description: "Pre-bid design and engineering support for a large-scale solar park development project in Rajasthan.",
    image: img1,
    link: "/projects/solar-bess"
  },
  {
    id: "02",
    tag: "WIND & HYBRID ENERGY",
    title: "120 MW Solar–Wind Hybrid Project",
    description: "Detailed project planning and engineering support for an integrated solar and wind facility.",
    image: img2,
    link: "/projects/wind"
  },
  {
    id: "03",
    tag: "BESS & RENEWABLE ENERGY",
    title: "15 MW Solar + 45 MWh BESS Project",
    description: "Financial modelling and bidding strategy support for an integrated solar and battery storage project.",
    image: img3,
    link: "/projects/hydrogen"
  }
];

const HomeProjects = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % projects.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + projects.length) % projects.length);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % projects.length);
  };

  return (
    <section className="home-projects-section">
      <Container>
        <Row className="align-items-start">
          {/* Left Content */}
          <Col lg={5} className="project-text-col">
            <div className="section-tag">
              Our Project
            </div>
            <h2 className="project-main-heading">
              Selected Projects & <br /> Expertise
            </h2>
            <div className="project-desc-wrap">
              <p className="project-description">
                From large-scale solar and hybrid projects to wind, BESS, and green energy initiatives, Dazbog supports projects across the renewable energy lifecycle.
              </p>
              
              <div className="project-nav-arrows">
                <button className="nav-btn prev" onClick={handlePrev} aria-label="Previous Project">
                  <FiArrowLeft />
                </button>
                <button className="nav-btn next" onClick={handleNext} aria-label="Next Project">
                  <FiArrowRight />
                </button>
              </div>
            </div>
          </Col>

          {/* Right Image Card */}
          <Col lg={7} className="project-card-col">
            <div className="project-main-card">
              <AnimatePresence mode="wait">
                <motion.div 
                   key={activeIndex}
                   initial={{ opacity: 0, x: 20 }}
                   animate={{ opacity: 1, x: 0 }}
                   exit={{ opacity: 0, x: -20 }}
                   transition={{ duration: 0.5 }}
                   className="project-card-inner"
                >
                  <div className="project-card-image">
                    <img 
                      src={projects[activeIndex].image} 
                      alt={projects[activeIndex].title} 
                      loading="lazy"
                      decoding="async"
                    />
                    <div className="card-overlay">
                      <div className="card-content-bottom">
                        <div className="card-tag-wrapper">
                           <span className="card-tag">{projects[activeIndex].tag}</span>
                        </div>
                        <h3 className="card-title2">{projects[activeIndex].title}</h3>
                        <p className="card-desc2">
                          {projects[activeIndex].description}
                        </p>
                        <div className="card-footer">
                          <span className="read-more-link" style={{ cursor: "pointer" }}>
                            Read more <FiArrowRight className="link-icon" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HomeProjects;
